import { LitElement, html, css } from 'lit';

class MetalyxCard extends LitElement {
  static properties = {
    heading: { type: String },
    icon: { type: String },
  };

  static styles = css`
    :host {
      display: block;
    }
    .card {
      background: var(--color-bg-card, #1E293B);
      border: 1px solid var(--color-border, rgba(255,255,255,0.08));
      border-radius: var(--radius-lg, 1rem);
      padding: 2rem;
      transition: all var(--transition, 200ms ease);
      height: 100%;
    }
    .card:hover {
      background: var(--color-bg-card-hover, #334155);
      transform: translateY(-2px);
      box-shadow: var(--shadow-card, 0 4px 24px rgba(0,0,0,0.3));
      border-color: var(--color-accent-glow, rgba(124, 58, 237, 0.3));
    }

    .icon-wrap {
      width: 48px;
      height: 48px;
      border-radius: var(--radius-md, 0.75rem);
      background: var(--color-accent-glow, rgba(124, 58, 237, 0.15));
      color: var(--color-accent, #7C3AED);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.25rem;
    }

    h3 {
      font-family: var(--font-heading, 'Outfit', sans-serif);
      font-size: var(--text-xl, 1.25rem);
      font-weight: 600;
      color: var(--color-text-heading, #fff);
      margin: 0 0 0.75rem;
    }

    .body {
      color: var(--color-text-muted, #64748B);
      font-size: var(--text-base, 1rem);
      line-height: 1.7;
    }
    .body ::slotted(*) {
      margin: 0;
    }
  `;

  constructor() {
    super();
    this.heading = '';
    this.icon = '';
  }

  render() {
    return html`
      <div class="card">
        ${this.icon
          ? html`<div class="icon-wrap"><metalyx-icon name="${this.icon}" size="24"></metalyx-icon></div>`
          : ''
        }
        ${this.heading ? html`<h3>${this.heading}</h3>` : ''}
        <div class="body"><slot></slot></div>
      </div>
    `;
  }
}

customElements.define('metalyx-card', MetalyxCard);